<template>
  <v-container fluid>
    <v-layout row>
      <Header title="Súhlas s používaním cookies" subtitle="www.duris.info" />
    </v-layout>
    <v-layout row wrap align-center justify-center fill-height class="pt-5">
      <v-flex xs12 sm6 md6 lg6>
        <p>
          <strong>Čo sú cookies a na čo ich potrebujeme?</strong>
        </p>
        <p>
          Súbory cookies sú malé textové súbory, ktoré sa ukladajú vo vašom
          prehliadači alebo mobilnom zariadení počas prezerania webových stránok.
        </p>
        <p>
          Jednotlivé cookies majú rôznu dobu uloženia vo vašom zariadení. Niektoré
          cookies sa vymažú z vášho zariadenia po tom, ako zatvoríte okno prehliadača
          (session cookie), iné zostávajú vo vašom zariadení uložené aj po ukončení
          prehliadania našich webových stránok (permanent cookie).
        </p>
        <p>
          <strong>Prečo používame cookies?</strong>
        </p>
        <p>
          Súbory cookies nám umožňujú zapamätať si vaše úkony v priebehu určitého
          časového obdobia. Pomáhajú nám pochopiť, čo vás zaujíma na našej webovej
          stránke, či je pre vás dostatočne prehľadná a viete na nej nájsť to, čo
          hľadáte. Cookies teda používame aj za účelom zlepšenia užívateľského
          zážitku.
        </p>
        <p>
          Súbory cookies môžu zaznamenávať aj ďalšie informácie, ako počet
          návštevníkov našich webových stránok a tiež aké podstránky najčastejšie
          navštevujete.
        </p>
        <p>
          <strong>Aké cookies používame?</strong>
        </p>
        <p>
          <em>Funkčné a technické cookies:</em>
          Tento druh súborov cookies je potrebný na samotné fungovanie webových
          stránok a ich prípadný zákaz môže značne sťažiť alebo úplne zamedziť
          prehliadanie webových stránok, preto si od vás nepýtame súhlas na ich
          uloženie a pristupovanie k nim. Tento druh cookies optimalizuje Vašu
          užívateľskú skúsenosť a ukladá informácie, ako sú napr. typ prehliadača,
          jazyk, veľkosť písma a iné nastavenia zobrazovania, a to aj po opustení
          webovej stránky.
        </p>
        <p>
          <em>Analytické cookies:</em>
          Tento druh súborov cookies slúži na získanie údajov o návštevnosti webovej
          stránky a tiež na zisťovanie, ako sa po našej stránke pohybujete, aby sme
          ju vedeli prispôsobovať tak, aby bola pre vás čo najjednoduchšou na
          používanie. Údaje získané prostredníctvom týchto súborov cookies nie sú
          spájané s jednotlivcami, ale využívané čisto na štatistické potreby a
          zlepšenie fungovania a užívateľskej optimálnosti webových stránok.
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
export default {
  name: "Cookies",
  components: {
    Header
  }
};
</script>

<style>
</style>